<section class="iq-pb-70 iq-sahpe">
    <img src="./assets/images/others/shape1.png" class="img-fluid shape" alt="QLOUD">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <app-title-section [titleSectionProp]="titleSectionProp" [currentApp]="currentApp"></app-title-section>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="iq-tabs iq-tab-vertical-1 iq-box-shadow">
                    <div class="row align-items-stretch">
                        <div class="col-lg-4">
                            <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                <li *ngFor="let nav of currentApp.navList" class="nav-item" (click)="makeActive(currentApp.navList,nav)">
                                    <a class="nav-link {{nav.active}}" data-toggle="pill" role="tab">
                                        <div class="media">
                                            <img src="{{ nav.image }}" width="60" class="img-fluid" alt="QLOUD">
                                            <div class="media-body">
                                                <h6 class="tab-title">{{ nav.title | translate }}</h6>
                                                <p class="mb-0 tab-title-desc">{{ nav.sub_title | translate }}</p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <div class="iq-btn-container mt-4">
                                        <a class="iq-button iq-btn-medium iq-btn-round iq-btn-flat d-inline" [routerLink]="['/downloads/', currentApp.link]"
                                            routerLinkActive="router-link-active">{{'DOWNLOAD' | translate}} {{currentApp.title | translate}}</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-8">
                            <div class="tab-content">
                                <div *ngFor="let nav of currentApp.navList" id="{{ nav.id }}" class="tab-pane fade  {{ nav.active !== undefined && nav.active ? 'show active' : '' }}">
                                    <div>
                                        <img class="img-fluid" [src]="nav.content_image + langService.activeLanguage+'.png'" alt="qloud">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
